module.exports = __webpack_public_path__ + "img/img1.d1d30efb.png";